const DRAG_DATA_KEY = 'application/x-sling-task';

export default function taskDraggable($rootScope) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      taskId: '@taskDraggable',
      fromColumn: '@taskFromColumn',
    },
    link(scope, element) {
      element[0].setAttribute('draggable', 'true');

      element.on('dragstart', (event) => {
        const payload = JSON.stringify({
          taskId: scope.taskId,
          fromColumn: Number(scope.fromColumn),
        });
        event.originalEvent.dataTransfer.setData(DRAG_DATA_KEY, payload);
        event.originalEvent.dataTransfer.effectAllowed = 'move';
        element.addClass('is-dragging');
        $rootScope.$broadcast('TASK-DRAG-START');
      });

      element.on('dragend', () => {
        element.removeClass('is-dragging');
        $rootScope.$broadcast('TASK-DRAG-END');
      });
    },
  };
}

export const DRAG_DATA_KEY_EXPORT = DRAG_DATA_KEY;
